<template>
  <div id="app">
    <md-app md-mode="reveal" class="mainApp">
      <md-app-toolbar class="md-primary">
        <md-button
          class="md-icon-button"
          v-if="$mq === 'mobile'"
          @click="menuVisible = !menuVisible"
        >
          <md-icon>menu</md-icon>
        </md-button>
        <span class="md-title clickable md-primary" @click="goTo('/')">Nico Pan</span>
        <md-button v-if="$mq !== 'mobile'" class="md-primary" @click="goTo('/me')">C'est moi !</md-button>
        <md-button v-if="$mq !== 'mobile'" class="md-primary" @click="goTo('/travel')">Aventures</md-button>
        <md-menu md-size="medium" v-if="$mq !== 'mobile'" md-align-trigger>
          <md-button md-menu-trigger>Boites a outils</md-button>

          <md-menu-content>
            <md-menu-item
              @click="goToWithParams('toolboxdisplay', { tool: item })"
              :key="item.title"
              v-for="item in getAllToolsBoxList"
            >{{item.title}}</md-menu-item>
          </md-menu-content>
        </md-menu>
        <md-button v-if="$mq !== 'mobile'" class="md-primary" @click="goTo('/map')">Map</md-button>
      </md-app-toolbar>
      <md-app-drawer :md-active.sync="menuVisible" v-if="$mq === 'mobile'">
        <md-list>
          <md-list-item @click="goTo('/', true) ">
            <md-icon>home</md-icon>
            <span class="md-list-item-text">Accueil</span>
          </md-list-item>
          <md-list-item @click="goTo('/me', true) ">
            <md-icon>face</md-icon>
            <span class="md-list-item-text">C'est moi</span>
          </md-list-item>

          <md-list-item @click="goTo('/travel', true)">
            <md-icon>flight_takeoff</md-icon>
            <span class="md-list-item-text">Aventures</span>
          </md-list-item>
          <md-list-item @click="goTo('/map', true)">
            <md-icon>language</md-icon>
            <span class="md-list-item-text">Map</span>
          </md-list-item>
          <md-list-item
            :key="item.ownId"
            v-for="item in getAllToolsBoxList"
            @click="goToWithParams('toolboxdisplay', { tool: item }, true)"
          >
            <md-icon>zoom_in</md-icon>
            <span class="md-list-item-text">{{item.title}}</span>
          </md-list-item>
        </md-list>
      </md-app-drawer>
      <md-app-content>
        <router-view />
      </md-app-content>
    </md-app>
    <!-- <div id="nav">
      <router-link to="/">Home</router-link>|
      <router-link to="/about">About</router-link>
    </div>-->

    <!-- <md-app-content>
      <router-view />
    </md-app-content>-->
  </div>
</template>
<script>
import Vue from "vue";
import { MdApp } from "vue-material/dist/components";
import { mapActions, mapGetters } from "vuex";
Vue.use(MdApp);
export default {
  name: "home",
  components: {},
  computed: {
    ...mapGetters(["getAllToolsBoxList"])
  },
  async mounted() {
    await this.getAllContinents();
    await this.getAllCountries();
    await this.getAllAdventures();
    await this.getAllArticles();
    await this.getMyData();
    await this.getAllToolsBox();
    await this.setStructure();
  },
  methods: {
    ...mapActions([
      "getAllContinents",
      "getAllArticles",
      "setStructure",
      "getAllCountries",
      "getAllAdventures",
      "getAllToolsBox",
      "getMyData"
    ]),
    goTo(route, closed) {
      this.$router.push(route);
      if (closed) {
        this.menuVisible = !this.menuVisible;
      }
    },
    goToWithParams(name, params, closed) {
      this.$router.push({ name: "toolboxdisplay", params });
      if (closed) {
        this.menuVisible = !this.menuVisible;
      }
    }
  },
  data: () => ({
    menuVisible: false
  })
};
</script>
<style lang="scss">
.md-field.md-theme-default.md-focused .md-input {
  color: #046380 !important;
}
.md-primary {
  background-color: #046380 !important;
  color: #efecca !important;
}

.md-ripple {
  background-color: #046380 !important;
  color: #efecca !important;
}

.md-list {
  background-color: #046380 !important;
  color: #efecca !important;
}

.md-icon {
  background-color: #046380 !important;
  color: #efecca !important;
}
.md-drawer {
  background-color: #046380 !important;
  color: #efecca !important;
}
.clickable {
  cursor: pointer;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
  background-color: #d4dadc !important;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.md-app {
  background-color: #d4dadc !important;
}

.vueEditorFixHeight {
  height: 40vh;
  margin-bottom: 50px;
  background-color: white;
}

@media only screen and (max-width: 959px) {
  .md-app-scroller {
    margin-top: 56px !important;
  }
}
</style>
